import React from 'react';

import CopyButton from 'shared/components/copy-button';
import Icon from 'shared/components/icon';

import styles from './icons.module.scss';

interface Props {
  name: string;
}

const IconCardButton = ({name}: Props) => (
  <CopyButton copyText={name} className={styles.button}>
    <Icon iconType={name} className={styles.icon} />
    {name}
  </CopyButton>
);

export default IconCardButton;
